import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Collapse, Spinner } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import UploadFiles from 'components/common/UploadFiles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { readProductBook } from 'helpers/excel';
import { faCloudDownloadAlt, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import SubProductForm from './SubProductForm';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Background from 'components/common/Background';
import SoftBadge from 'components/common/SoftBadge';
import classNames from 'classnames';
import useScreenSize from 'hooks/useScreenSize';
import bg2 from 'assets/img/icons/spot-illustrations/corner-3.png';
import { setStatus } from 'helpers/utils';

const SubProducts = ({ article }) => {
 const { width } = useScreenSize();
 const { control, setValue, watch, getValues } = useFormContext();
 const { fields, append, update, remove } = useFieldArray({ control, name: 'products' });

 const financings = watch('financings') ?? [];

 const [open, setOpen] = useState(false);
 const [product, setProduct] = useState({});
 const [options, setOptions] = useState([]);
 const [isLoading, setIsLoading] = useState(false);
 const [code, setCode] = useState(getValues('article') ?? null);

 useEffect(() => {
  if (!article?.references) return;

  let optionss = article?.references.map(e => ({
   label: e.reference,
   options: e.properties.map(a => ({ value: a._id, label: a.name }))
  }));

  if (financings.length)
   optionss = [{ label: 'Financiaciones', options: financings.map(e => ({ value: e.name, label: e.name })) }, ...optionss];

  setOptions(optionss);
  const articleCode = getValues('article');
  if (articleCode !== code) {
   setCode(articleCode);
   setValue('products', []);
  }
 }, [article]);

 useEffect(() => {
  setOptions(options => {
   const option = !financings.length
    ? []
    : [{ label: 'Financiaciones', options: financings.map(e => ({ value: e.name, label: e.name })) }];

   return [...option, ...options.filter(e => e.label !== 'Financiaciones')];
  });
  //   setValue('products', []);
 }, [financings]);

 const regroupRef = references => {
  return references.map(val => {
   const data = options.find(group => group.options.some(option => option.value === val)) ?? {};
   return { label: data?.label, value: data?.options.find(e => e.value === val)?.label ?? null };
  });
 };

 const handleDownload = () => {
  // URL del archivo que deseas descargar
  const fileUrl =
   'https://firebasestorage.googleapis.com/v0/b/inmovilii.appspot.com/o/fixed%2FProductCreation.xlsx?alt=media&token=83b69c8a-5663-435d-ac50-fe25d1495efa';

  // Crea un enlace (a) oculto para simular la descarga
  const link = document.createElement('a');
  link.href = fileUrl;
  link.setAttribute('download', '');

  // Añade el enlace al documento
  document.body.appendChild(link);

  // Dispara el clic en el enlace para iniciar la descarga
  link.click();

  // Elimina el enlace del documento
  document.body.removeChild(link);
 };

 return (
  <>
   <Card className="mb-3 bg-transparent border">
    <Card.Header>
     <Flex alignItems="center" wrap="nowrap">
      <div className="flex-fill px-3 border-start border-start-400">
       <Flex justifyContent="start" alignItems="center" wrap="nowrap">
        {/* <h6 className="fa-stack me-2 ms-n1 circle-dashed cursor-pointer" style={{ width: '35px', height: '35px' }}>
         <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
         <FontAwesomeIcon icon={faCloudDownloadAlt} className="fa-inverse fa-stack-1x fs--1 text-primary" ransform="shrink-3" />
        </span> */}
        <Button variant="falcon-success" type="button" className="icon-item icon-item-sm" onClick={handleDownload}>
         <FontAwesomeIcon className="fs-0" icon={faCloudDownloadAlt} />
        </Button>
        <div className="ms-2 d-none d-sm-block display-6">
         <h5 className="mb-0 text-success fs-0 display-6">Bajar</h5>
         <p className="mb-0 fs--2">Excel.xlsx</p>
        </div>
       </Flex>
      </div>

      <div className="flex-fill px-3 border-start border-start-dark">
       <UploadFiles
        buffer={true}
        multiple={false}
        dropzoneArea={false}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        isLoading={e => setIsLoading(e)}
        onChange={book => {
         const libro = readProductBook(['Products', 'Financings'], book);
         //  const Financings = libro.find(e => e.Financings)?.Financings;
         console.log({ libro });
        }}
        placeholder={
         <Flex justifyContent="start" alignItems="center" wrap="nowrap">
          {isLoading ? (
           <Spinner animation="grow" role="status" className="fa-stack me-2 ms-n1" style={{ width: '35px', height: '35px' }}>
            <FontAwesomeIcon icon="circle" className="fa-stack-2x fs--1 text-300" />
            <FontAwesomeIcon icon={faCloudUploadAlt} className="fa-inverse fa-stack-1x fs--1 text-primary" ransform="shrink-3" />
           </Spinner>
          ) : (
           <Button variant="falcon-success" type="button" className="icon-item icon-item-sm">
            <FontAwesomeIcon className="fs-0" icon={faCloudUploadAlt} />
           </Button>
          )}
          <div className="ms-2 d-none d-sm-block display-6">
           <h5 className="mb-0 text-success fs-0 display-6">Subir</h5>
           <p className="mb-0 fs--2">Excel.xlsx</p>
          </div>
         </Flex>
        }
       />
      </div>

      <div className="flex-fill ps-3 border-start border-start-400">
       <Flex justifyContent="between" alignItems="center" wrap="nowrap">
        <div className="display-6">
         <h5 className="mb-0 text-success fs-0 display-6">Crear</h5>
         <p className="mb-0 fs--2">Productos</p>
        </div>
        <Button variant="falcon-success" type="button" className="icon-item icon-item-sm" onClick={() => setOpen(!open)}>
         <FontAwesomeIcon className="fs-0" icon={open ? 'chevron-up' : 'chevron-down'} />
        </Button>
       </Flex>
      </div>
     </Flex>
    </Card.Header>

    {options.length ? (
     fields.map((prod, index) => {
      const { references, tag, quantity, status, stock } = prod;
      const std = setStatus(status);
      const refs = regroupRef(references);
      return (
       <Card key={index} className={classNames('bg-transparent border m-3', { 'mt-0': index })}>
        <Background image={bg2} className="bg-card" />
        <Card.Body className="hover-actions-trigger fs--1 p-3">
         <Flex className="">
          <div className="flex-fill d-flex align-items-center">
           <h6 className="mb-0 me-3 d-none d-md-block">Etiqueta:</h6>
           <h6 className="mb-0 fs--1 display-6">{tag}</h6>
          </div>
          <div className="flex-fill d-flex align-items-center">
           <h6 className="mb-0 me-3 d-none d-md-block">Cantidad:</h6>
           <h6 className="mb-0 fs--1 display-6">{quantity}</h6>
           <h6 className="ms-1 mb-0 fs--2 align-self-start">{article?.measuring}</h6>
          </div>
          <div className="flex-fill d-flex align-items-center">
           <h6 className="mb-0 me-3 d-none d-md-block">Stock:</h6>
           {stock ? (
            <h6 className="mb-0 fs--1 display-6">{stock}</h6>
           ) : (
            <FontAwesomeIcon icon="infinity" className="text-primary" />
           )}
          </div>
          <div className="flex-fill">
           <SoftBadge pill bg={std.bg}>
            {std.tag}
            <FontAwesomeIcon icon={std.icon} className={`ms-1 text-${std.color}`} />
           </SoftBadge>
          </div>
         </Flex>

         <div className="d-flex flex-column align-items-start">
          <h6 className="my-1 text-primary fs--2">Referencias</h6>
          <Flex>
           {refs.map((ref, i) => (
            <div key={i} className="px-2 flex-fill">
             <h6 className="text-700 fs--2 mb-1">
              {ref?.label}
              <SoftBadge pill bg="success" className="ms-2">
               {ref?.value}
               <FontAwesomeIcon icon="caret-up" className="ms-1" />
              </SoftBadge>
             </h6>
            </div>
           ))}
          </Flex>
         </div>

         <div className={classNames('end-0 top-0 p-1 p-md-0 hover-actions', { 'translate-middle-y': width > 425 })}>
          <Button
           variant="link"
           type="button"
           className="d-flex align-items-center fs--1 text-700 p-0"
           onClick={() => {
            setOpen(true);
            setProduct({ ...prod, index });
           }}
          >
           <FontAwesomeIcon icon="pencil-alt" />
          </Button>

          <Button
           size="sm"
           variant="link"
           type="button"
           className="d-flex align-items-center fs-1 text-700 p-0 ms-3"
           onClick={() => remove(index)}
          >
           <FontAwesomeIcon icon="times-circle" />
          </Button>
         </div>
        </Card.Body>
       </Card>
      );
     })
    ) : (
     <></>
    )}

    <Collapse in={open}>
     <Card.Body className="pt-0 pt-md-3" id="formFnc">
      <SubProductForm product={product} options={options} append={append} update={update} fields={fields} setOpen={setOpen} />
     </Card.Body>
    </Collapse>
   </Card>
  </>
 );
};

SubProducts.propTypes = {
 article: PropTypes.object
};

SubProducts.defaultProps = { article: {} };

export default SubProducts;
